import axios from 'axios';
import UserUtils from "../component/utils/UserUtils";

const USER_API_BASE_URL = process.env.REACT_APP_API_URL + '/api/case';

class CaseService {

    fetchCaseById(caseId, customerCode, siteCode) {
        // return axios.get(USER_API_BASE_URL + '/' + caseId);
        return axios({
            url: USER_API_BASE_URL + '/' + caseId,
            method: 'GET',
            headers: {
                'code-site': siteCode,
                'code-client': customerCode
            }
        })
    }

    fetchSearchCases(filters, messagesIndicator, isSuivi) {
        let filtersIndicator = {
            ...filters,
            messagesIndicator : messagesIndicator,
            isSuivi : isSuivi
        }
        return axios({
            url: USER_API_BASE_URL + '/advanced-search',
            method: 'post',
            data: filtersIndicator,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            }
        })
    }

    postGuaranteeDecision(guarantee, prolongation, date) {
        const user = UserUtils.getUser();

        return axios({
            url: USER_API_BASE_URL + '/case/guarantee-decision',
            method: 'post',
            data: {
                ...guarantee,
                ...{prolongation, date},
                ...{ auteur: user.email }
            },
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            }
        })
    }

    fetchGuaranteeCases(page, customerCodes) {
        if (!page) {
            page = 0;
        }

        return axios({
            url: USER_API_BASE_URL + '/cases/with-guarantee',
            method: 'get',
            params: {
                page,
                codeClients: customerCodes
            },
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            }
        })
    }

    fetchUpdateCaseStatus(caseId, status, employeeId) {
        const query = 
            {
                "caseId": caseId,
                "status": status,
                "employeeId": employeeId
            }
        return axios.post(USER_API_BASE_URL + '/update', query);
    }

    fetchDirectoryPictures(numDossier, moyen) {
        let infoDirectory = {
            "numDossier" : numDossier,
            "moyen" : moyen
        }
        return axios({
            url: USER_API_BASE_URL + '/pictures/directory',
            method: 'POST',
            data: infoDirectory,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            }
        })
    }

    fetchPicturesByDirectory(directory) {
        return axios.get(USER_API_BASE_URL + '/pictures/'+directory);
    }
}

export default new CaseService();